import { enumValidator } from '#validation/common/validators';
import { DomainSsoEnforcement } from '../constants';
export const domainSsoEnforcementValidator = enumValidator({
    values: DomainSsoEnforcement,
    invalidValueError: 'verifiedDomainConfig.ssoEnforcementType.invalid',
});
